module.exports = __webpack_public_path__ + "static/media/img3.79c46039.jpg";